import i18n from 'i18next';
import en from './locales/en';
import it from './locales/it';

i18n
  .init({
    fallbackLng: 'it',
    debug: true,

    resources : {
      en,
      it
    },

    lng: localStorage.getItem('language'),

    initImmediate: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    // react i18next special options (optional)
    react: {
      wait: false,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    }
  });

export default i18n;


// WEBPACK FOOTER //
// ./src/I18n/I18n.js